angular.module('pacaapp', [
    'app.core',
    'app.layout',
    'app.common',
    'app.home',
    'app.search',
    'app.vehicledetails',
    'app.staticpage',
    'app.contactus',
    'angularCSS'
]);



// WEBPACK FOOTER //
// ./app/app.module.js